export default __webpack_public_path__ + "static/media/hadoop.28101dac.svg";